import { Anchor, Box, Button, Header, Nav, Text } from 'grommet'
import styled, { css } from 'styled-components'

import { InputField } from '@fields/InputField'
import Handset from '@public/images/handset-icon.svg'
import { Link } from '@ui/links/Link'

export const Input = styled(InputField).attrs({
  className: 'input-name',
  errorMsgVariant: 'errorWhiteBG',
})``

export const ContentContainer = styled('div')`
  margin-bottom: ${({ theme }) => theme.spaces[2]}px;
  position: ${({ info }) => (info ? 'none' : 'relative')};

  .addInfo {
    display: none;
    position: absolute;
    height: 225px;
    padding: ${({ theme }) => theme.spaces[3] + 9}px;
    width: 326px;
  }

  & > span:hover,
  span:focus-within {
    .addInfo {
      display: block;
      top: ${({ theme }) => theme.spaces[3] + 9}px;
      right: ${({ theme }) => theme.spaces[3] + 9}px;
      background: ${({ theme }) => theme.colors.darkCloud};
      z-index: 10;
    }
  }

  &:last-child {
    margin-bottom: ${({ theme }) => theme.spaces[0]}px;
  }

  &:hover,
  :focus-within {
    .additional-box {
      display: flex;
    }
  }
`

export const ContentWrapper = styled('div')`
  align-items: center;
  align-items: baseline;
  display: flex;
  flex-direction: ${({ column }) => (column ? 'row' : 'column')};
  margin-bottom: ${({ theme }) => theme.newSpaces.xs2 + theme.newSpaces.xs3}px;
  padding: ${({ theme }) => theme.newSpaces.xs2}px 0;
  position: relative;

  img {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
  }

  .content {
    cursor: pointer;
    font-weight: ${({ theme }) => theme.fontWeight[4]};
    padding-left: ${({ theme }) => theme.spaces[4] + 13}px;
    position: relative;
    transition: 0.3s;

    ${({ theme }) => theme.below.tablet`
      font-size: ${theme.fontSizes[3]}px;
      line-height: ${theme.lineHeight[1]}px;
    `}

    ${({ theme }) => theme.below.mobileL`
      font-size: ${theme.fontSizes[2]}px;
      line-height: ${theme.lineHeight[0]}px;
    `}

    &:hover {
      color: ${({ theme }) => theme.colors.orangeGrey};
    }

    img {
      left: 0;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
    }

    .arrow {
      left: auto;
      right: -${({ theme }) => theme.spaces[4]}px;
    }
  }

  p {
    color: ${({ theme }) => theme.colors.gray};
    font-size: ${({ theme }) => theme.fontSizes[2]}px;
    font-weight: ${({ theme }) => theme.fontWeight[3]};
    padding-left: ${({ theme }) => theme.spaces[4] + 13}px;

    ${({ theme }) => theme.below.tablet`
      font-size: ${theme.fontSizes[3]}px;
      line-height: ${theme.lineHeight[1]}px;
    `}

    ${({ theme }) => theme.below.mobileL`
      font-size: ${theme.fontSizes[2]}px;
      line-height: ${theme.lineHeight[0]}px;
    `}
  }

  &:last-child {
    margin-bottom: ${({ theme }) => theme.spaces[0]}px;
  }

  ${({ theme }) => theme.below.laptop`
    font-size: ${theme.fontSizes[4]}px;
    line-height: ${theme.lineHeight[1] + 2}px;
 `}
  ${({ theme }) => theme.below.tablet`
    font-size: ${theme.fontSizes[2]}px;
    line-height: ${theme.lineHeight[4]}px;
  `}
`

export const Wrapper = styled(Header)`
  flex-direction: row;
  padding: 21px 0;
  transition: 0.4s;
  width: 100%;
  z-index: 7;

  ${({ theme }) => theme.below.laptop`
    height: ${({ open }) => (open ? '100%' : '0')};
    overflow: ${({ open }) => (open ? 'auto' : 'none')};
    flex-direction: column;
    justify-content: flex-start;
    top: ${theme.spaces[0]};
    right: ${theme.spaces[0]};
    z-index: 10;
    margin:${theme.spaces[0]}px;
  `}
`

export const LogoWrapper = styled(Box)`
  display: flex;
  justify-content: space-between;
  min-width: 120px;

  ${({ theme }) => theme.below.laptop`
    flex-direction: row;
    width: 100%;
    z-index:1;
  `}
`

export const LinkButton = styled(Link)`
  ${({ theme }) => css`
    align-items: center;
    background-color: transparent;
    border: 1px solid ${theme.newColors.secondary};
    color: ${theme.newColors.secondary};
    display: flex;
    font-size: ${({ theme }) => theme.spaces[3]}px;
    font-weight: ${({ theme }) => theme.fontWeight[4]};
    height: 40px;
    justify-content: center;
    margin-right: 130px;
    text-decoration: none;
    width: 145px;

    &:hover {
      background-color: ${theme.newColors.secondary};
      color: ${theme.newColors.dark};
      text-decoration: none;

      ${({ theme }) => theme.below.laptop`
        background-color: ${theme.colors.white};
        color: ${theme.colors.secondary};
      `}
    }

    ${({ theme }) => theme.below.laptop`
      display: ${({ open }) => (open ? 'flex' : 'none')};
      align-self: center;
      justify-self: flex-end;
      background-color: #2C3144;
      color: white;
      border: none;
      padding: ${theme.spaces[4]}px 0;
      font-size: ${theme.fontSizes[3]}px;
      margin-top: ${theme.spaces[2]}px;
      width: 40%;
      order: 2;
      margin-right: 0;
    `}

    ${({ theme }) => theme.below.tablet`
      font-size: ${theme.fontSizes[2]}px;
      width: 60%;
      padding: ${theme.spaces[3]}px 0;
    `}

    ${({ theme }) => theme.below.mobileL`
      padding: ${theme.spaces[3] + theme.spaces[2]}px 0;
      width: 80%;
    `}
  `}
`

export const List = styled.nav`
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  list-style: none;
  max-width: 850px;
  width: 100%;

  & > span:nth-child(7) {
    & > a {
      text-align: center;
      width: 40px;
    }
  }

  & > div {
    display: none;
  }

  ${({ theme }) => theme.below.laptopL`
    gap: ${theme.newSpaces.sm}px;
  `}

  ${({ theme }) => theme.below.laptop`
    max-width: unset;
    display: ${({ open }) => (open ? 'flex' : 'none')};
    flex-flow: column nowrap;
    flex-grow: 1;
    align-items: flex-start;
    justify-content: flex-start;
    top: ${theme.spaces[0]};
    right: ${theme.spaces[0]};
    background-color: ${theme.colors.white};
    width: 100%;
    margin-top:${theme.spaces[5]}px;
    padding: ${theme.spaces[0]};
    margin-right: ${theme.spaces[0]}px;
    max-height: 500px;
    overflow: ${({ open }) => (open ? 'auto' : 'none')};

    &::-webkit-scrollbar {
      width: 8px;
    }

    &::-webkit-scrollbar-thumb {
      background-color: rgb(134, 146, 166);
      border-radius: 2px;
    }

    & > div {
      display:none;
    }
  `}

  @media (max-width: 400px) and (max-height: 700px) {
    margin-top: ${({ theme }) => theme.spaces[4]}px;
  }

  & > span:hover,
  span:focus-within {
    & > div {
      display: inline-block;
    }

    .submenu,
    .adaptive-content {
      display: flex;
      flex-direction: row;
      height: initial;
    }

    .first-part {
      transform: rotate(0deg);
    }

    .plus-wrapper {
      ${({ theme }) => theme.below.laptop`
        display:none;
      `}
    }
  }
`

export const ListItem = styled(Text)`
  align-items: center;
  box-shadow: none;
  display: flex;
  flex-wrap: nowrap;
  font-size: ${({ theme }) => theme.fontSizes[14]}px;
  position: relative;

  &::after {
    align-self: center;
    color: ${({ theme, $active }) =>
      $active ? theme.colors.orangeGrey : theme.colors.milkyWhite};
    content: ${({ info }) => (info ? `'>'` : 'none')};
    line-height: 1px;
    position: absolute;
    right: 6px;
    transform: rotate(90deg);
    transition: 0.2s;

    ${({ theme, open }) => theme.below.laptop`
      transform: ${open ? 'rotate(180deg)' : 'translateY(-50%)'};
      top: ${open ? `25px` : '50%'};
      font-size: ${theme.fontSizes[5]}px;
      right: ${open ? 'auto' : `${theme.spaces[4]}px`};
      left: ${open ? `${theme.spaces[1]}px` : 'auto'};
      color: ${theme.colors.secondary};
      font-weight: ${theme.fontWeight[4]};
      transition: none;
    `}

    ${({ theme }) => theme.below.tablet`
      font-size: ${theme.fontSizes[4]}px;
    `}

    ${({ theme }) => theme.below.mobileL`
      font-size: ${theme.fontSizes[3]}px;
    `}
  }

  &:hover,
  :focus-within {
    text-decoration: none;

    & > div > span {
      text-decoration: underline;
    }

    &::after {
      top: 50%;
      transform: translateY(-50%);

      ${({ theme, open }) => theme.below.laptop`
      transform: ${open ? 'rotate(180deg)' : 'translateY(-50%)'};
      top: ${open ? `25px` : '50%'} !important;
    `}
    }

    &::before {
      bottom: -${({ theme }) => theme.spaces[3] + 4}px;
      content: '';
      left: 0;
      padding-bottom: ${({ theme }) => theme.spaces[3] + 4}px;
      position: absolute;
      width: 100%;

      ${({ theme }) => theme.below.laptop`
        content: none;
    `}
    }
  }

  ${({ theme }) => theme.below.laptop`
    width: 100%;
    &:not(:last-child) {
      margin-right: 0;
    }
`}
`

export const AdditionalInfoSubtitle = styled(Text)`
  ${({ theme }) => css`
    color: ${theme.colors.secondary};
    font-size: ${theme.typography.desktop.body.body3.fontSize - 1}px;
    font-weight: ${theme.typography.desktop.body.body3.fontWeight};
    margin-bottom: ${theme.spaces[2]}px;
  `}
`

export const PopUpWindow = styled(Box)`
  background-color: ${({ theme }) => theme.colors.backLight};
  box-shadow: 0 0 ${({ theme }) => theme.spaces[2]}px
    ${({ theme }) => theme.colors.smokeWhite};
  display: none;
  flex-direction: row;
  height: ${({ height }) => (height ? `${height}px` : '240px')};
  justify-content: space-between;
  left: ${({ left }) => left};
  margin-top: ${({ theme }) => theme.spaces[3] + 4}px;
  max-width: none;
  overflow: hidden;
  padding: ${({ theme }) => theme.spaces[3] + 9}px;
  position: absolute;
  width: ${({ width }) => (width ? `${width}px` : '365px')};

  img {
    left: ${({ theme }) => theme.spaces[5]}px;
    position: relative;
    top: ${({ theme }) => theme.spaces[5]}px;
  }

  ${({ theme }) => theme.below.laptop`
    background-color: ${theme.colors.primary};
  `}

  & p {
    font-size: ${({ theme }) => theme.fontSizes[14]}px;
    font-weight: ${({ theme }) => theme.fontWeight[8]};
    margin-bottom: ${({ theme }) => theme.spaces[3]}px;
    ${({ theme }) => theme.below.tablet`
      font-size: ${theme.fontSizes[2]}px;
      margin-bottom:4px;
    `}
  }
`

export const Symbol = styled('span')`
  align-items: center;
  cursor: pointer;
  display: flex;
  font-size: ${({ theme }) => theme.fontSizes[3]}px;
  justify-content: center;
  margin-left: ${({ theme }) => theme.spaces[2] + 2}px;
  padding-left: 0;
  transform: ${({ open }) => (open ? 'rotate(90deg)' : 'none')};
  transition: 0.2s;

  &:hover {
    color: ${({ theme }) => theme.colors.orangeGrey};
  }
`

export const Links = styled(Link)`
  align-items: center;
  color: ${({ theme, $active }) =>
    $active ? theme.colors.orangeGrey : theme.colors.milkyWhite};
  display: flex;
  font-size: ${({ theme }) => theme.fontSizes[14]}px;
  font-weight: ${({ theme }) => theme.fontWeight[2]};
  justify-content: space-between;
  padding-right: ${({ theme, withPadding }) =>
    withPadding ? theme.newSpaces.sm : 0}px;
  position: relative;
  transition: 0.3s;
  white-space: nowrap;

  &:hover {
    text-decoration: underline;
  }

  ${({ theme, $active, open }) => theme.below.laptop`
    font-size: ${theme.fontSizes[5]}px;
    font-weight: ${theme.fontWeight[4]};
    line-height: ${theme.lineHeight[3] + 1}px;
    width: 100%;
    color: ${$active ? theme.colors.primary : theme.colors.secondary};
    padding-left: ${open ? `${theme.spaces[4] + 13}px` : '0'};
  `}

  ${({ theme, open }) => theme.below.tablet`
    font-size: ${theme.fontSizes[4]}px;
    padding-left: ${open ? `${theme.spaces[4]}px` : '0'};
    padding-right: ${theme.spaces[2]}px;
    &::after {
      width: 9px;
    }
  `}

  ${({ theme }) => theme.below.mobileL`
    font-size: ${theme.fontSizes[3]}px;
    padding-right: ${theme.spaces[2]}px;
    &::after {
      width: 9px;
    }
  `}
`

export const BurgerMenuButton = styled(Button)`
  display: none;
  ${({ theme }) => theme.below.laptop`
    display: flex;
    align-items: center;
    align-self: flex-start;
  `}
`

export const PlusWrapper = styled.div`
  cursor: pointer;
  display: flex;
  height: 20px;
  position: relative;
  width: 20px;

  ${({ theme }) => theme.below.laptop`
    display:none;
  `}
  div {
    background-color: ${({ theme }) => theme.colors.primary};
    border-radius: 2px;
    cursor: pointer;
    height: 0.15rem;
    position: absolute;
    right: ${({ theme }) => theme.spaces[1]}px;
    top: ${({ theme }) => theme.spaces[2]}px;
    width: 0.6rem;
  }

  & > div:first-child {
    position: absolute;
    right: ${({ theme }) => theme.spaces[1]}px;
    top: ${({ theme }) => theme.spaces[2]}px;
    transform: rotate(90deg);
    transition: all 0.2s linear;
  }
`

export const PopupDescription = styled(Box)`
  background: ${({ theme }) => theme.colors.darkCloud};
  height: 225px;
  min-width: ${({ theme }) => theme.maxWidth[2] + 6}px;
  padding: ${({ theme }) => theme.spaces[3] + 9}px;

  span:hover {
    text-decoration: none;
  }
`

export const PopUpSectionWrapper = styled(Box)`
  border-right: ${({ theme, hexagon }) =>
    hexagon ? `1px solid ${theme.colors.darkCloud}` : 'none'};
  display: flex;
  flex-direction: column;
  width: ${({ theme }) => theme.maxWidth[0]}px;

  &:nth-child(2) > div > span::after {
    content: '>';
    padding-left: ${({ theme }) => theme.spaces[2]}px;
  }
`

export const LogoLink = styled(Anchor)`
  box-shadow: none;
`

export const LinkWrapper = styled.span``

export const Content = styled(Link)`
  box-shadow: none;
  color: ${({ theme, $active }) =>
    $active ? theme.colors.orangeGrey : theme.colors.secondary};
  font-size: ${({ theme }) => theme.fontSizes[2] - 1}px;
  font-weight: ${({ theme, active }) =>
    active ? theme.fontWeight[7] : theme.fontWeight[2]};
  margin-bottom: ${({ theme }) => theme.spaces[2]}px;
  text-decoration: ${({ open }) => (open ? 'underline' : 'none')};

  &:last-child {
    margin-bottom: ${({ theme }) => theme.spaces[0]}px;
  }

  ${({ theme }) => theme.above.laptop`
    &:hover {
      text-decoration: ${({ active }) => (active ? 'none' : 'underline')};
      text-decoration-color: ${theme.colors.primary};
      text-underline-offset: 2px;
    }
  `}
  ${({ theme }) => theme.below.laptop`
    margin-bottom: ${theme.spaces[0]}px;
    font-size: ${theme.fontSizes[3]}px;
    line-height: ${theme.lineHeight[1]}px;
  `}
  ${({ theme }) => theme.below.tablet`
    font-size: ${theme.fontSizes[2]}px;
    line-height: ${theme.lineHeight[4]}px;
  `}
`

export const AdaptiveContent = styled(Box)`
  display: ${({ open }) => (open ? 'flex' : 'none')};
  flex-direction: column;
  margin-top: ${({ theme }) => theme.spaces[2]}px;
  padding: ${({ theme }) => theme.spaces[2]}px;
`

export const AdaptiveSectionContent = styled(Box)`
  margin-right: ${({ theme }) => theme.spaces[4]}px;
  max-width: 180px;

  ${({ theme }) => theme.below.laptop`
    max-width: 500px;
   `}

  &:last-child {
    margin-right: 0;
  }
`

export const AdaptiveSectionHeading = styled(Text)`
  color: ${({ theme }) => theme.colors.cloudGrey};
  font-size: ${({ theme }) => theme.fontSizes[2]}px;
  font-weight: ${({ theme }) => theme.fontWeight[3]};
  margin: ${({ theme }) => theme.newSpaces.xs2 + theme.newSpaces.xs3}px 0;
  text-transform: uppercase;

  ${({ theme }) => theme.below.tablet`
    // font-size: ${theme.fontSizes[3]}px;
    // margin: ${theme.spaces[2]}px 0;
   `}

  ${({ theme }) => theme.below.mobileL`
    font-size:${theme.fontSizes[1]}px;
   `}
`

export const AdditionalList = styled.ul`
  display: ${({ open }) => (open ? 'flex' : 'none')};
  flex-direction: column;
  gap: ${({ theme }) => theme.newSpaces.xs2}px;
  margin-bottom: 10px;
  margin-left: ${({ theme }) => theme.spaces[3] + 9}px;
`

export const AdditionalContent = styled.li`
  color: ${({ theme }) => theme.colors.secondary};
  cursor: pointer;
  list-style: none;
  padding-left: ${({ theme }) => theme.spaces[3] + 4}px;
  transition: 0.3s;

  & span:hover {
    color: ${({ theme }) => theme.colors.orangeGrey};
  }

  > div {
    color: ${({ theme }) => theme.colors.darkGray};
    text-decoration: none;

    &:hover {
      text-decoration: none;
    }
  }
`

export const Container = styled(Box)`
  align-items: center;
  align-self: center;
  background: ${({ theme }) => theme.colors.gradientGray};
  border-bottom: ${({ theme, isVisible }) =>
    isVisible ? `2px solid ${theme.colors.milkyWhite}` : '0px'};
  position: fixed;
  transition: 0.3s;
  width: 100%;
  z-index: 8;

  ${({ theme, open }) => theme.below.laptop`
    min-height: 82px;
    padding: 0 ${theme.spaces[3]}px;
    background: ${open ? theme.colors.white : theme.colors.gradientGray};
    height: ${open ? '100dvh' : '82px'};
    overflow-y: ${open ? 'auto' : 'unset'};
  `}
`

export const Block = styled(Box)`
  display: flex;
  width: 100%;
`

export const AdditionalPathContent = styled(Box)`
  background-color: transparent;
  display: none;
  flex-direction: column;
  white-space: nowrap;
`

export const AdditionalPathWrapper = styled('div')`
  left: ${({ theme }) => theme.spaces[7] + 70}px;
  position: absolute;
  top: 0;
  z-index: ${({ theme }) => theme.spaces[2]};

  &::before {
    content: '';
    left: -${({ theme }) => theme.spaces[4]}px;
    padding-left: ${({ theme }) => theme.spaces[4]}px;
    padding-top: 100px;
    position: absolute;
    top: 0;
  }
`

export const SocialList = styled(Nav)`
  align-self: center;
  column-gap: ${({ theme }) => theme.newSpaces.md}px;
  display: ${({ open }) => (open ? 'flex' : 'none')};
  flex-direction: row;
  justify-content: space-between;
  list-style: none;
  margin-top: ${({ theme }) => theme.newSpaces.md}px;
  order: 2;
  div {
    display: none;
  }
`

export const SocialListItem = styled(Text)`
  box-shadow: none;
`

export const FooterUi = styled(Box)`
  ${({ theme }) => theme.below.laptop`
    background-color: ${theme.colors.white};
    display: flex;
    width: 100%;
    z-index: 7;
  `}
`

export const LinkToFooterWrapper = styled(Box)`
  display: flex;
  position: relative;

  ${({ theme }) => theme.below.laptop`
    width: 100%;
    margin-top: ${theme.spaces[4]}px;

    & > div:nth-child(1) {
      order: 1;
    }
  `}
`

export const ButtonContainer = styled(Button)`
  height: 40px;
  margin-right: ${({ theme }) => theme.spaces[3] + 4}px;
  position: relative;
  right: ${({ theme }) => theme.spaces[3] + 6}px;

  ${({ theme }) => theme.below.laptop`
    right: ${theme.spaces[0]};
  `}
`

export const ButtonBookCall = styled.div`
  align-items: center;
  color: ${({ theme }) => theme.colors.milkyWhite};
  cursor: pointer;
  display: flex;
  justify-content: space-around;
  left: ${({ theme }) => theme.spaces[6] + theme.spaces[3]}px;
  margin-bottom: ${({ theme }) => theme.spaces[3]}px;
  margin-left: ${({ theme }) => theme.newSpaces.sm}px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 135px;
  &:hover {
    text-decoration: underline;
    .book-call {
      transform: scale(1.05);
      transition: all 0.3s ease-in-out;
      .handset-icon_svg__first-arc {
        animation: appearance1 2s infinite;
        @keyframes appearance1 {
          30% {
            opacity: 0;
          }
          40% {
            opacity: 1;
          }
          100% {
            opacity: 1;
          }
        }
      }
      .handset-icon_svg__second-arc {
        animation: appearance2 2s infinite;
        @keyframes appearance2 {
          50% {
            opacity: 0;
          }
          60% {
            opacity: 1;
          }
          100% {
            opacity: 1;
          }
        }
      }
      .handset-icon_svg__last-arc {
        animation: appearance3 2s infinite;
        @keyframes appearance3 {
          70% {
            opacity: 0;
          }
          80% {
            opacity: 1;
          }
          100% {
            opacity: 1;
          }
        }
      }
    }
  }
  ${({ theme }) => theme.below.laptop`
    display: ${({ open }) => (open ? 'flex' : 'none')};
    position: relative;
    align-self:center;
    height: 30px;
    padding: ${theme.spaces[4]}px 0;
    font-size: ${theme.fontSizes[3]}px;
    margin-top:${theme.spaces[2]}px;
    width: 40%;
    order: 1;
    border: 2px solid ${theme.colors.primary};
    color: ${theme.colors.primary};
    font-weight: ${theme.fontWeight[4]};
    justify-content: center;
    text-decoration: none;
    left: ${theme.spaces[0]};
    margin-left: ${theme.spaces[0]};
    &:hover {
      text-decoration: none;
    }
  `}
  ${({ theme }) => theme.below.tablet`
    width: 60%;
    padding: ${theme.spaces[3]}px 0;
  `}
  ${({ theme }) => theme.below.mobileL`
  padding: ${theme.spaces[3] + theme.spaces[2]}px 0;
  width:80%;
`}
`

export const HandsetIcon = styled(Handset)`
  margin-right: 2px;
  transform: scale(0.9);

  path {
    stroke: ${({ theme }) => theme.newColors.secondary};
  }

  .handset-icon_svg__last-arc {
    opacity: 0;
  }

  ${({ theme }) => theme.below.laptop`
    margin-right: 6px;

    path {
      stroke:  transparent;
    }
  `}
`

export const WrapperPopUp = styled(Box)`
  height: 100vh;
  overflow: auto;
  position: fixed;
  top: 55px;
  width: 100vw;
  z-index: 10;
`

export const PopupWrapper = styled.div`
  height: 100%;
  width: 100%;

  ${({ theme }) => theme.below.laptop`
    background: ${theme.colors.white};
  `}

  ${({ theme }) => theme.below.tablet`
    overflow: auto;
    min-height: 1050px;
  `}
`

export const PopUpSecondForm = styled(PopupWrapper)`
  ${({ theme }) => theme.below.tablet`
    min-height: 720px;
  `}
`

export const Popup = styled.div`
  background: ${({ theme }) => theme.colors.white};
  border-radius: 3px;
  box-shadow: 0px 0px 10px 0px rgba(34, 60, 80, 0.7);
  height: auto;
  margin: 50px 20px 0 0;
  max-width: 650px;
  overflow: hidden;
  padding: ${({ theme }) => theme.spaces[3] + 9}px;
  position: absolute;
  right: ${({ theme }) => theme.spaces[0]};
  z-index: 1000;

  img {
    bottom: -71px;
    position: absolute;
    right: -46px;

    ${({ theme }) => theme.below.tablet`
    bottom: 255px;
    right: -88px;
  `}
  }

  ${({ theme }) => theme.below.desktop`
     right: 20%;
  `}

  ${({ theme }) => theme.below.laptopL`
    right: 15%;
  `}

  ${({ theme }) => theme.below.laptopM`
    right: 8%;
  `}

  ${({ theme }) => theme.below.laptop`
    top: 50%;
    left: 50%;
    right: auto;
    transform: translate(-50%, -50%);
    margin: 0;
  `}

  ${({ theme }) => theme.below.tablet`
    height: auto;
    top: 20px;
    transform: translate(-50%, 0);
    border: none;
  `}

  ${({ theme }) => theme.below.mobileM`
    padding: ${theme.spaces[2]}px;
  `}

  .rdp {
    border: 1px solid ${({ theme }) => theme.colors.secondary};
    bottom: ${({ theme }) => theme.spaces[4] + 1}px;
    margin: 0;
    margin-right: ${({ theme }) => theme.spaces[2] + 3}px;
    position: relative;

    .rdp-cell:first-child {
      color: #990000;
    }
    .rdp-cell:last-child {
      color: #990000;
    }
    ${({ theme }) => theme.below.laptop`
    margin-right: 0;
  `}
  }
  .rdp-caption {
    position: relative;
    right: ${({ theme }) => theme.spaces[3] - 1}px;
  }
  .rdp-nav {
    position: relative;
  }
  .rdp-table {
    font-size: ${({ theme }) => theme.fontSizes[3]}px;
  }
  .rdp-caption_label {
    color: ${({ theme }) => theme.colors.primary};
    font-size: ${({ theme }) => theme.fontSizes[2]}px;
    font-weight: ${({ theme }) => theme.fontWeight[6]};
    left: ${({ theme }) => theme.spaces[3] - 1}px;
    line-height: ${({ theme }) => theme.lineHeight[4]}px;
    position: relative;
  }
  .rdp-button {
    font-family: 'Product Sans';
    font-style: normal;
    font-weight: ${({ theme }) => theme.fontWeight[4]};
    line-height: ${({ theme }) => theme.lineHeight[4]}px;
  }
  .rdp {
    --rdp-accent-color: ${({ theme }) => theme.colors.primary};
    --rdp-background-color: ${({ theme }) => theme.colors.primary};
    --rdp-cell-size: 40px;
    --rdp-outline-selected: 2px solid rgba(0, 0, 0, 0.75);
  }
`

export const CalendarWrapper = styled.div`
  align-items: center;
  color: ${({ theme }) => theme.colors.secondary};
  display: flex;
  flex-direction: column;
  height: 500px;
  justify-content: space-between;
  width: 295px;

  &:first-child {
    justify-content: start;

    ${({ theme }) => theme.below.tablet`
      height: 400px;
  `}

    & > span:first-child {
      margin-bottom: 60px;
      padding-left: ${({ theme }) => theme.spaces[5]}px;
      position: relative;
      text-align: left;
      width: 100%;

      img {
        left: 0;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
      }
    }
  }

  &:last-child {
    padding-left: ${({ theme }) => theme.spaces[3]}px;

    ${({ theme }) => theme.below.tablet`
      padding-left: 0;
  `}
  }
`

export const CalendarText = styled(Text)`
  font-family: 'Lexend Deca';
  font-size: ${({ theme }) => theme.fontSizes[3]}px;
  font-weight: ${({ theme }) => theme.fontWeight[2]};
  line-height: ${({ theme }) => theme.lineHeight[4] + 2}px;
  margin-top: ${({ theme }) => theme.spaces[4]}px;
  text-align: left;
`

export const CalendarPeronalInfo = styled(Text)`
  color: ${({ theme }) => theme.colors.secondary};
  display: flex;
  font-family: 'Lexend Deca';
  font-size: ${({ theme }) => theme.fontSizes[1]}px;
  font-weight: ${({ theme }) => theme.fontWeight[5]};
  line-height: ${({ theme }) => theme.lineHeight[6]}px;
  margin-top: ${({ theme }) => theme.spaces[3]}px;
  text-align: center;
`

export const CalendarTextSubtitle = styled(Text)`
  color: #f17900;
  font-family: 'Lexend Deca';
  font-size: ${({ theme }) => theme.fontSizes[0]}px;
  font-weight: ${({ theme }) => theme.fontWeight[4]};
  line-height: ${({ theme }) => theme.lineHeight[6] - 3}px;
  text-align: center;
  .select {
    font-size: 14px;
  }
`

export const CalendarTextWrapper = styled.div`
  text-align: center;
  width: 250px;
`

export const InfoDateWrapper = styled.div`
  display: flex;
  height: 500px;
  max-width: 590px;

  ${({ theme }) => theme.below.tablet`
    flex-direction: column;
    height: auto;
  `}
`

export const ButtonTime = styled.div`
  align-items: center;
  border: 1px solid #8692a6;
  color: #8692a6;
  display: flex;
  font-family: 'Lexend Deca';
  font-size: ${({ theme }) => theme.fontSizes[1]}px;
  font-weight: ${({ theme }) => theme.fontWeight[4]};
  height: 34px;
  justify-content: center;
  line-height: ${({ theme }) => theme.lineHeight[6]}px;
  transition: 0.3s;
  width: 66px;

  &:hover {
    border: 1px solid ${({ theme }) => theme.colors.secondary};
    color: ${({ theme }) => theme.colors.secondary};
  }
`

export const ButtonWrapper = styled.div`
  cursor: pointer;
  display: flex;
  height: auto;
  justify-content: space-around;
  width: 260px;

  .active {
    background: ${({ theme }) => theme.colors.secondary};
    color: ${({ theme }) => theme.colors.white};
  }
`

export const SubtitleDate = styled.div`
  font-family: 'Lexend Deca';
  font-size: ${({ theme }) => theme.fontSizes[1]}px;
  font-weight: ${({ theme }) => theme.fontWeight[5]};
  line-height: ${({ theme }) => theme.lineHeight[6]}px;
  margin: ${({ theme }) => theme.spaces[2 + 2]}px 0;
  text-align: center;
  width: 250px;
`

export const TimeZoneWrapper = styled(Box)`
  border: 1px solid ${({ theme }) => theme.colors.secondary};
  padding: ${({ theme }) => theme.spaces[2] + 2}px;
`

export const TimeZone = styled(Button)`
  height: 175px;
  overflow: auto;
  width: 246px;

  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: rgb(134, 146, 166);
    border-radius: 2px;
  }

  .active {
    width: 250px;
  }
`

export const TimeWrapper = styled.input`
  display: none;

  &:checked + label {
    background: ${({ theme }) => theme.colors.secondary};
    color: ${({ theme }) => theme.colors.white};
  }
`

export const DurabilityBlock = styled.div`
  align-items: center;
  display: flex;
  font-family: 'Lexend Deca';
  font-size: ${({ theme }) => theme.fontSizes[1]}px;
  font-weight: ${({ theme }) => theme.fontWeight[4]};
  height: 34px;
  justify-content: center;
  line-height: ${({ theme }) => theme.lineHeight[6]}px;
  width: 66px;
`

export const DurabilityButton = styled.input`
  display: none;

  &:checked + label {
    background: ${({ theme }) => theme.colors.secondary};
    color: white;
  }
`

export const DurabilityText = styled.label`
  align-items: center;
  border: 1px solid ${({ theme }) => theme.newColors.blueGray};
  color: ${({ theme }) => theme.newColors.blueGray};
  cursor: pointer;
  display: flex;
  height: ${({ theme }) => theme.spaces[4]}px;
  justify-content: center;
  text-align: center;
  transition: 0.3s;
  width: inherit;

  &:hover {
    border: 1px solid ${({ theme }) => theme.colors.secondary};
    color: ${({ theme }) => theme.colors.secondary};
  }
`

export const TimeText = styled.label`
  align-items: center;
  border: 1px solid ${({ theme }) => theme.newColors.blueGray};
  color: ${({ theme }) => theme.newColors.blueGray};
  cursor: pointer;
  display: flex;
  height: 100%;
  justify-content: center;
  transition: 0.3s;
  width: 225px;

  &:hover {
    border: 2px solid ${({ theme }) => theme.colors.secondary};
    color: ${({ theme }) => theme.colors.secondary};
  }
`

export const TimeButtonWrapper = styled(Box)`
  align-items: center;
  display: flex;
  height: 34px;
  justify-content: center;
  margin: ${({ theme }) => theme.spaces[2]}px;
`

export const ButtonSubmitWrapper = styled(Box)`
  align-items: flex-end;
  display: flex;
  width: 100%;
`

export const ButtonSubmit = styled(Button)`
  align-items: center;
  border: 1px solid #f17900;
  color: #f17900;
  display: flex;
  height: 40px;
  justify-content: center;
  text-align: center;
  transition: 0.3s;
  width: 145px;

  & > div:first-child {
    top: 46%;
    left: 17%;

    ${({ theme }) => theme.below.tablet`
      width: 35px;
      height: 35px;
      left: 8%;
      top: 46%;
  `}
  }

  &:hover {
    background: #f17900;
    color: ${({ theme }) => theme.colors.white};
  }

  ${({ theme }) => theme.below.tablet`
      width: 100%;
  `}
`

export const ButtonEdit = styled(Button)`
  align-items: center;
  color: #f17900;
  display: flex;
  font-family: 'Lexend Deca';
  font-size: ${({ theme }) => theme.fontSizes[1]}px;
  font-weight: ${({ theme }) => theme.fontWeight[5]};
  line-height: ${({ theme }) => theme.lineHeight[6]}px;
  margin-left: ${({ theme }) => theme.spaces[2]}px;
  padding-left: ${({ theme }) => theme.spaces[3] + 2}px;
  position: relative;
  text-align: right;

  img {
    left: 0;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }
`

export const FormWrapper = styled.div`
  height: 500px;
  width: 520px;
`

export const Wrap = styled(Box)`
  height: auto;
  width: 100%;

  &:first-child {
    margin-top: ${({ theme }) => theme.spaces[3]}px;
  }
`

export const ContentWrapperForm = styled.form`
  ${({ theme }) => theme.below.laptop`
    padding: 0 ${theme.spaces[3]}px;
  `}
`

export const InputWrap = styled.div`
  display: flex;
  flex-direction: column;
  margin: ${({ theme }) => theme.spaces[1]}px;

  & p {
    font-size: ${({ theme }) => theme.fontSizes[1]}px;
    margin-left: ${({ theme }) => theme.spaces[2]}px;
  }

  input,
  textarea {
    padding: ${({ theme }) => theme.spaces[2]}px;
  }

  .input-name {
    border: 1px solid #8692a6;
    height: 39px;
    width: 267px;

    ${({ theme }) => theme.below.tablet`
      width: 285px;
    `}
  }
  .input-email {
    height: 39px;
    width: 543px;

    ${({ theme }) => theme.below.tablet`
      width: 285px;
    `}
  }
  .comment {
    height: 107px;
    resize: none;
    width: 543px;

    ${({ theme }) => theme.below.tablet`
      width: 285px;
    `}
  }
  position: relative;
`

export const ButtonBack = styled(Button)`
  border: 1px solid ${({ theme }) => theme.colors.secondary};
  color: ${({ theme }) => theme.colors.secondary};
  height: 40px;
  text-align: center;
  transition: 0.3s;
  width: 145px;

  &:hover {
    background: ${({ theme }) => theme.colors.secondary};
    color: ${({ theme }) => theme.colors.white};
  }

  ${({ theme }) => theme.below.tablet`
      width: 100%;
  `}
`

export const ButtonForm = styled.div`
  display: flex;
  justify-content: space-between;
  margin: ${({ theme }) => theme.spaces[1] - 1}px;
  width: 543px;

  ${({ theme }) => theme.below.tablet`
      width: 285px;
      flex-direction: column;
  `}
`

export const WrapStep = styled.div`
  color: #bdbdbd;
  display: flex;
  font-family: 'Lexend';
  font-size: ${({ theme }) => theme.fontSizes[2]}px;
  font-weight: ${({ theme }) => theme.fontWeight[4]};
  justify-content: space-between;
  line-height: ${({ theme }) => theme.lineHeight[4]}px;

  div {
    margin-top: 0;
  }
`

export const ContWrapDiv = styled.div`
  margin-top: ${({ theme }) => theme.spaces[3]}px;

  & .return-btn {
    width: 200px;

    ${({ theme }) => theme.below.tablet`
      width: 100%;
  `}
  }

  label {
    margin-left: ${({ theme }) => theme.spaces[1]}px;
  }
`

export const Label = styled.label``

export const ContWithFlex = styled.div`
  display: flex;

  ${({ theme }) => theme.below.tablet`
    flex-direction: column;
  `}
`

export const TitleMeetup = styled.div`
  font-family: 'Lexend Deca';
  font-size: ${({ theme }) => theme.fontSizes[14]}px;
  font-weight: ${({ theme }) => theme.fontWeight[4]};
  line-height: ${({ theme }) => theme.lineHeight[4] + 2}px;
  margin-top: ${({ theme }) => theme.spaces[4]}px;

  ${({ theme }) => theme.below.tablet`
      width: 295px;
  `}
`

export const CloseBtn = styled(Button)`
  align-items: center;
  color: #bdbdbd;
  display: flex;
  font-family: 'Lexend Deca';
  font-size: ${({ theme }) => theme.fontSizes[2]}px;
  font-weight: ${({ theme }) => theme.fontWeight[4]};
  line-height: ${({ theme }) => theme.lineHeight[4]}px;
  transition: 0.3s;

  &:hover {
    color: ${({ theme }) => theme.colors.secondary};
  }
`

export const SubTitleMeetup = styled.div`
  color: ${({ theme }) => theme.colors.secondary};
  font-family: 'Lexend Deca';
  font-size: ${({ theme }) => theme.fontSizes[2]}px;
  font-weight: ${({ theme }) => theme.fontWeight[2]};
  line-height: ${({ theme }) => theme.lineHeight[4]}px;
  margin-top: ${({ theme }) => theme.spaces[3]}px;

  ${({ theme }) => theme.below.tablet`
      width: 295px;
  `}
`

export const InfoMeetup = styled.div`
  align-items: center;
  border: 1px solid #8692a6;
  color: ${({ theme }) => theme.colors.secondary};
  display: flex;
  flex-wrap: wrap;
  font-family: 'Lexend Deca';
  font-size: ${({ theme }) => theme.fontSizes[1]}px;
  font-weight: ${({ theme }) => theme.fontWeight[3]};
  height: 140px;
  justify-content: space-around;
  line-height: ${({ theme }) => theme.lineHeight[6]}px;
  margin: ${({ theme }) => theme.spaces[4] + 8}px 0;
  width: 535px;

  ${({ theme }) => theme.below.tablet`
      width: 295px;
  `}
`

export const ContWrapMeetup = styled.div`
  padding-left: ${({ theme }) => theme.spaces[4]}px;
  position: relative;
  width: 250px;

  svg {
    left: 0;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }
`
